let currentAudioId = null;

let audioContext = null;
let playTime = 0;

let isLoading = false;
let isPlaying = false;
let isPaused = false;

let sources = [];

export function startStream(id) {
    currentAudioId = id;
    isLoading = true;
    isPlaying = false;
    isPaused = false;

    audioContext = new AudioContext({ sampleRate: 24000 });
    playTime = audioContext.currentTime;
}

export function onFirstChunk() {
    if (!isPlaying) {
        isLoading = false;
        isPlaying = true;
        isPaused = false;
    }
}

export function pauseStream() {
    if (!audioContext || !isPlaying) return;

    audioContext.suspend();
    isPaused = true;
    isPlaying = false;
}

export function resumeStream() {
    if (!audioContext || !isPaused) return;

    audioContext.resume();
    isPaused = false;
    isPlaying = true;
}

export function stopStream() {
    sources.forEach(s => {
        try { s.stop(); s.disconnect(); } catch {}
    });
    sources = [];

    audioContext?.close();
    audioContext = null;

    currentAudioId = null;
    isLoading = false;
    isPlaying = false;
    isPaused = false;
}

export function registerSource(source) {
    sources.push(source);

    source.onended = () => {
        sources = sources.filter(s => s !== source);

        if (sources.length === 0) {
            isPlaying = false;
            isLoading = false;
            isPaused = false;
        }
    };
}

export function getState(id) {
    return {
        isLoading: isLoading && currentAudioId === id,
        isPlaying: isPlaying && currentAudioId === id,
        isPaused: isPaused && currentAudioId === id
    };
}

export function getContext() {
    return audioContext;
}

export function getPlayTime() {
    return playTime;
}

export function setPlayTime(t) {
    playTime = t;
}
